import { SubscribeForm } from './index';
import { Footer } from '../../../components/index';

export const FooterFinal = () => {
   return (
      <div>
         {window.innerWidth > 900 && <img alt='event-collage' src={"./assets/media/bottom collage fvs22.png"} style={{ width: '100%', height: 'auto' }} />}
         <SubscribeForm id={`subscribeForm5`} />
         {<Footer />}
      </div>
   )
}
